import { useAppState } from 'contexts/PropertyEditContext';
import { userRoles } from 'utils/enums';

export default function useCanCreateContract() {
  const { profile } = useAppState();

  return [userRoles.LANDLORD, userRoles.PROPERTY_MANAGER].includes(profile?.type) && profile?.canCreateContract;
}
